'use strict'

const INSTRUMENT_KPI_REPORT_ID_API_SUCCESS = 'INSTRUMENT_KPI_REPORT_ID_API_SUCCESS';
const INSTRUMENT_KPI_REPORT_ID_API_FAILURE = 'INSTRUMENT_KPI_REPORT_ID_API_FAILURE';
const INSTRUMENT_KPI_GROUP_ID_API_SUCCESS = 'INSTRUMENT_KPI_GROUP_ID_API_SUCCESS';
const INSTRUMENT_KPI_GROUP_ID_API_FAILURE = 'INSTRUMENT_KPI_GROUP_ID_API_FAILURE';
const INSTRUMENT_KPI_GROUP_ID_TYPE_TABLE = 'PHX_CRITICAL_WARNING_INSTRUMENT_KPI';
const INSTRUMENT_KPI_GROUP_ID_REPORT_KPI = 'PHX_RPT_PBI_INSTRUMENT_KPI_';
const POWERBI_TABLENAME_KPI = 'PHX_CRITICAL_WARNING_INSTRUMENT_KPI';

const POWERBI_GROUP_URL ='https://api.powerbi.com/v1.0/myorg/groups';
const INSTRUMENT_KPI_DEVICE_STATE_ADD = 'INSTRUMENT_KPI_DEVICE_STATE_ADD';
const INSTRUMENT_KPI_DEVICE_STATE_REMOVE = 'INSTRUMENT_KPI_DEVICE_STATE_REMOVE';

export {
    INSTRUMENT_KPI_REPORT_ID_API_SUCCESS,
    INSTRUMENT_KPI_REPORT_ID_API_FAILURE,
    INSTRUMENT_KPI_GROUP_ID_API_SUCCESS,
    INSTRUMENT_KPI_GROUP_ID_API_FAILURE,
    INSTRUMENT_KPI_GROUP_ID_TYPE_TABLE,
    INSTRUMENT_KPI_GROUP_ID_REPORT_KPI,
    POWERBI_GROUP_URL,
    POWERBI_TABLENAME_KPI,
    INSTRUMENT_KPI_DEVICE_STATE_ADD,
    INSTRUMENT_KPI_DEVICE_STATE_REMOVE
}